import axios, { AxiosRequestConfig, AxiosResponse } from "axios"
import { CSRF_MISMATCH, notifyError, notifyErrors, UNAUTHENTICATED } from "@helpers"
import { startLoading, finishLoading } from "@blocks/Loading"

/**
 * This file customizes axios when page loads.
 */ 
axios.defaults.withCredentials = true
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
axios.interceptors.request.use(onSuccessfulRequest, onFailedRequest)
axios.interceptors.response.use(onSuccessfulResponse, onFailedResponse)

// FUNCTIONS
function onFailedResponse(err: Responses.Error) {
    finishLoading()
    if (err.response.status !== 404) 
        handleError(err)
    throw err
}

function onSuccessfulResponse(res: AxiosResponse<any>) {
    finishLoading()
    return res
}

function onFailedRequest(err: any) {
    handleError(err)
    return Promise.reject(err)
}

function onSuccessfulRequest(req: AxiosRequestConfig) {
    startLoading()
    return req
}

function handleError(error: Responses.Error) {
    if (error.message === UNAUTHENTICATED || error.response?.data?.message === UNAUTHENTICATED || error?.response?.data?.message === CSRF_MISMATCH) {
        notifyError("You're unauthenticated. Please, log in again.")
        setTimeout(() => window.location.reload(), 1000)
        return
    }
    
    if (!error.response || !error.response.data) throw error.message

    if ('errors' in error.response.data)
        notifyErrors(error.response.data.errors!)
    else
        notifyError(error.response.data.message)
}